import type { NodePropertySchema } from '../../../types/node-properties';

const schema: NodePropertySchema = {
  nodeType: 'langchain-vector-store',
  version: '1.0.0',
  properties: [
    {
      key: 'operation',
      label: 'Operation',
      type: 'options',
      required: true,
      default: 'insert',
      options: [
        { value: 'insert', name: 'Insert Documents' },
        { value: 'search', name: 'Search' },
        { value: 'delete', name: 'Delete' },
      ],
    },
    {
      key: 'vectorStore',
      label: 'Vector Store',
      type: 'options',
      required: true,
      default: 'pinecone',
      options: [
        { value: 'pinecone', name: 'Pinecone' },
        { value: 'chroma', name: 'Chroma' },
        { value: 'qdrant', name: 'Qdrant' },
        { value: 'weaviate', name: 'Weaviate' },
      ],
    },
    {
      key: 'credentialId',
      label: 'Credential',
      type: 'string',
      required: true,
      typeOptions: {
        credentialType: '={{$parameter["vectorStore"]}}',
      },
    },
    {
      key: 'indexName',
      label: 'Index Name',
      type: 'string',
      required: true,
      placeholder: 'my-index',
    },
    {
      key: 'query',
      label: 'Search Query',
      type: 'string',
      displayOptions: {
        show: {
          operation: ['search'],
        },
      },
      typeOptions: {
        rows: 3,
      },
    },
    {
      key: 'topK',
      label: 'Top K Results',
      type: 'number',
      default: 5,
      displayOptions: {
        show: {
          operation: ['search'],
        },
      },
      typeOptions: {
        minValue: 1,
        maxValue: 100,
      },
    },
  ],
};

export default schema;
